// import { useState } from "react";
import classNames from "classnames";
import { HiBell } from "react-icons/hi";

// assets
import styles from "@/assets/styles/components/Footer/landing-footer.module.scss";

interface LandingFooterSubscribeButtonProps {
  label?: string;
  type?: "default" | "primary";
  className?: string;
  onButtonClick?: () => void;
}

const LandingFooterSubscribeButton = ({
  label = "Subscribe",
  type = "default",
  className = "",
  onButtonClick
}: LandingFooterSubscribeButtonProps) => {
  return (
    <>
      <button
        className={classNames(
          styles["locl-subscribe-button"],
          styles[`locl-subscribe-button_type-${type}`],
          className
        )}
        onClick={onButtonClick}
        data-testid="locl-subscribe-button"
      >
        <HiBell className={styles["locl-subscribe-button__icon"]} />
        <span className={styles["locl-subscribe-button__label"]}>{label}</span>
      </button>
    </>
  );
};

export default LandingFooterSubscribeButton;
